import React from 'react';

import type { SVGProps } from 'react';

const ExclamationTriangleIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.95382 1.51177C5.96684 1.50454 5.98311 1.5 6.00116 1.5C6.01921 1.5 6.03548 1.50454 6.0485 1.51177C6.05975 1.51802 6.07461 1.52944 6.08954 1.55484L11.2323 10.3048C11.259 10.3504 11.2585 10.398 11.2339 10.4423C11.2215 10.4646 11.2061 10.4793 11.1928 10.4875C11.1818 10.4943 11.1675 10.5 11.1439 10.5H0.858443C0.834775 10.5 0.820533 10.4943 0.80949 10.4875C0.796222 10.4793 0.780792 10.4646 0.768456 10.4423C0.743852 10.398 0.743314 10.3504 0.77006 10.3048L5.91278 1.55484C5.9277 1.52944 5.94257 1.51802 5.95382 1.51177ZM6.73613 1.17482C6.40322 0.608395 5.59909 0.608395 5.26618 1.17482L0.123469 9.92482C-0.219305 10.508 0.192209 11.25 0.858443 11.25H11.1439C11.8101 11.25 12.2216 10.508 11.8788 9.92482L6.73613 1.17482Z"
      fill="white"
    />
    <path
      d="M5.25116 9C5.25116 8.58579 5.58694 8.25 6.00116 8.25C6.41537 8.25 6.75116 8.58579 6.75116 9C6.75116 9.41421 6.41537 9.75 6.00116 9.75C5.58694 9.75 5.25116 9.41421 5.25116 9Z"
      fill="white"
    />
    <path
      d="M5.32463 4.49628C5.28467 4.09671 5.59844 3.75 6 3.75C6.40156 3.75 6.71533 4.09671 6.67537 4.49628L6.41231 7.12686C6.39113 7.33869 6.21288 7.5 6 7.5C5.78712 7.5 5.60887 7.33869 5.58769 7.12686L5.32463 4.49628Z"
      fill="white"
    />
  </svg>
);

export default ExclamationTriangleIcon;
